import logErrorWithContext from '@hmhco/client-monitoring/src/context/logErrorWithContext';
import OktaSignIn from '@okta/okta-signin-widget';
import OktaAuth from '@okta/okta-auth-js';
import { handleAuthRedirect } from '../../../util/handleAuthRedirect';

export const createAndDisplayOktaWidget = async (oktaInfo, widgetRef) => {
  try {
    const oktaWidget = new OktaSignIn(oktaInfo);
    const authClient = new OktaAuth(oktaInfo);

    await authClient.session.exists().then(exists => {
      if (exists) {
        authClient.session.close();
      }
    });

    oktaWidget
      .showSignIn({
        el: widgetRef.current,
      })
      .then(res => handleAuthRedirect(res.interaction_code, res.state))
      .catch(error => {
        logErrorWithContext(
          'OktaSignIn widget failed to showSignInAndRedirect',
          [{ key: 'error', value: error }],
        );
      });

    return oktaWidget;
  } catch (error) {
    logErrorWithContext('OktaSignIn widget failed to initialize', [
      { key: 'error', value: error },
    ]);
  }

  return null;
};

export default createAndDisplayOktaWidget;
